<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c3Iwe2/tc-custom/9781479872176.jpg?1719927329543" alt="This image is the cover for the book Unfreedom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unfreedom
      </h1>
      <p class="bookDescription body article font2">
        <p>Choice Outstanding Academic Title of 2016<br/><br/><b>Reveals the lived experience of slaves in eighteenth-century Boston</b><br/><br/> Instead of relying on the traditional dichotomy of slavery and freedom, Hardesty argues we should understand slavery in Boston as part of a continuum of unfreedom. In this context, African slavery existed alongside many other forms of oppression, including Native American slavery, indentured servitude, apprenticeship, and pauper apprenticeship. In this hierarchical and inherently unfree world, enslaved Bostonians were more concerned with their everyday treatment and honor than with emancipation, as they pushed for autonomy, protected their families and communities, and demanded a place in society.<br/><br/>Drawing on exhaustive research in colonial legal records – including wills, court documents, and minutes of governmental bodies – as well as newspapers, church records, and other contemporaneous sources, Hardesty masterfully reconstructs an eighteenth-century Atlantic world of unfreedom that stretched from Europe to Africa to America. By reassessing the lives of enslaved Bostonians as part of a social order structured by ties of dependence, Hardesty not only demonstrates how African slaves were able to decode their new homeland and shape the terms of their enslavement, but also tells the story of how marginalized peoples engrained themselves in the very fabric of colonial American society.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jared Ross Hardesty
      </h2>
      
      <p class="authorDescription body article"><B>Jared Ross Hardesty</B><B></B>is Associate Professor<B></B>in the Department of History<B></B>at Western Washington University and author of <I>Unfreedom: Slavery and Dependence in Eighteenth-Century Boston </I>(NYU Press, 2018),<I> Black Lives, Native Lands, White Worlds: A History of Slavery in New England</I> (University of Massachusetts, 2019),<I></I>and <I>Mutiny on the Rising Sun: A Tragic Tale of Slavery, Smuggling, and Chocolate </I>(NYU Press, 2021).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47034b12